(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["confy-bundle"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-confy-bundle]');
    if (!form || !window.ConfyCart) return;
    e.preventDefault();
    const input = form.querySelector('input[name="id"]:checked');
    const btn = form.querySelector('[data-confy-atc]');
    const err = form.querySelector('.confy-bundle__error');
    if (!input) return;
    btn.classList.add('is-busy');
    err.hidden = true;
    try {
      await window.ConfyCart.addBundle(Number(input.value), input.dataset.gift === 'true');
    } catch (x) {
      err.textContent = x.message;
      err.hidden = false;
    }
    btn.classList.remove('is-busy');
  });
  } catch(e) { console.error(e); }
})();

})();
